import { getPallettesByCategoryAndBucket as l } from "@placer-ui/components";
import "@turf/turf";
import "./index.es175.js";
import { rgbArrayToHex as e } from "./index.es277.js";
import "./index.es176.js";
var r;
const o = (r = l("demographics", 5).find(
  (t) => t.paletteName === "Teal"
)) == null ? void 0 : r.paletteColors, c = [
  {
    color: e(o[0]),
    value: "0 to 35",
    ranges: [0, 35],
    visible: !0
  },
  {
    color: e(o[1]),
    value: "35 to 40",
    ranges: [35, 40],
    visible: !0
  },
  {
    color: e(o[2]),
    value: "40 to 45",
    ranges: [40, 45],
    visible: !0
  },
  {
    color: e(o[3]),
    value: "45 to 50",
    ranges: [45, 50],
    visible: !0
  },
  {
    color: e(o[4]),
    value: "50 to 90",
    ranges: [50, 90],
    visible: !0
  }
];
export {
  c as MEDIAN_AGE_BINS
};
//# sourceMappingURL=index.es471.js.map
